import type { JSX } from 'react';
import {
  CALLING_CODES_HELP,
  callingCodesProblem,
  SENDER_HELP,
  senderProblem,
} from '../lib/use-cases';
import { Field } from '@/components/ui/field';
import { Input } from '@/components/ui/input';

/**
 * Fields of the SMS settings of a use case (lot 17), validated live with the
 * domain rules the API applies. Each renders a labelled `Field`: the input,
 * its help and, while the value breaks a rule, the problem.
 */

export function SenderField({
  value,
  onChange,
  label = 'Expéditeur',
}: {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}): JSX.Element {
  return (
    <Field label={label} required hint={SENDER_HELP} error={senderProblem(value)}>
      <Input
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        maxLength={11}
        placeholder="ACME"
        autoComplete="off"
        spellCheck={false}
      />
    </Field>
  );
}

export function CallingCodesField({
  value,
  onChange,
  label = 'Indicatifs autorisés',
}: {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}): JSX.Element {
  return (
    <Field label={label} required hint={CALLING_CODES_HELP} error={callingCodesProblem(value)}>
      <Input
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        placeholder="33, 262"
        autoComplete="off"
        className="font-mono"
      />
    </Field>
  );
}
